import * as React from 'react';

import { uniqueIdFactory } from '../../../../../api/quiz/getQuizzes/normalize/uniqueIds';

interface TrashFolderActions {
  restoreFolder: (uniqueId: string) => void;
  purgeFolder: (uniqueId: string) => void;
}

const TrashFolderActionContext =
  React.createContext<TrashFolderActions>(undefined);

export interface TrashFolderActionProviderProps {
  children: React.ReactNode;
  onRestoreFolder: (folderId: number) => void;
  onPurgeFolder: (folderId: string) => void;
}

export function TrashFolderActionProvider({
  children,
  onRestoreFolder,
  onPurgeFolder,
}: TrashFolderActionProviderProps) {
  const folderActions = React.useMemo(
    () => ({
      restoreFolder: (uniqueId: string) => {
        onRestoreFolder(uniqueIdFactory.folder.toEntityId(uniqueId));
      },
      purgeFolder: (uniqueId: string) => {
        onPurgeFolder(uniqueId);
      },
    }),
    [onRestoreFolder, onPurgeFolder]
  );

  return (
    <TrashFolderActionContext.Provider value={folderActions}>
      {children}
    </TrashFolderActionContext.Provider>
  );
}

export function useTrashFolderActions() {
  const context = React.useContext(TrashFolderActionContext);

  if (context === undefined) {
    throw new Error(
      'useTrashFolderActions must be used within TrashFolderActionContext'
    );
  }

  return context;
}
